import { User } from '@/models/User';
import { birthday } from '@/support/Date';
export class Reseller extends User {
    constructor() {
        super(...arguments);
        this.$name = 'Reseller';
        this.$fillable = ['avatar', 'name', 'first_name', 'middle_name', 'last_name', 'dob', 'email', 'password', 'school', 'reseller', 'phone', 'roles', 'parnassys_id'];
        this.filters = {
            role: 'reseller',
        };
    }
    setDobAttribute(value) {
        this.age = birthday(value);
        return value;
    }
    url() {
        return '/resellers/' + this.id;
    }
}
